// Créditos: sprites animados (PMD Sprite Repository, CC BY-NC 4.0), ícones de
// itens (PokéAPI) e aviso de marca.
import type { View } from "../router";
import { esc, screen } from "../ui";
import { t } from "../i18n";

interface Credits {
  sprites: { name: string; url: string; license: string; artists: string[] };
  items: { name: string; url: string };
}

export const creditsView: View = (root) => {
  root.innerHTML = screen(t("credits.title"), "/titulo", `<div class="bw-textbox">${t("common.loading")}</div>`);
  const body = root.querySelector<HTMLElement>(".screen__body")!;
  void fetch("/assets/credits.json")
    .then((r) => r.json() as Promise<Credits>)
    .then((c) => {
      body.innerHTML = `
        <section class="bw-panel bw-stack">
          <div class="bw-panel__header">${t("credits.sprites")}</div>
          <p>${t("credits.spritesText", { source: `<a href="${esc(c.sprites.url)}" target="_blank" rel="noopener">${esc(c.sprites.name)}</a>`, license: esc(c.sprites.license) })}</p>
          <ul class="credits-list">${c.sprites.artists.map((a) => `<li>${esc(a)}</li>`).join("")}</ul>
        </section>
        <section class="bw-panel bw-stack">
          <div class="bw-panel__header">${t("credits.items")}</div>
          <p>${t("credits.itemsText", { source: `<a href="${esc(c.items.url)}" target="_blank" rel="noopener">${esc(c.items.name)}</a>` })}</p>
          <p>${t("credits.fonts")}</p>
        </section>
        <p class="bw-dim small">${t("credits.trademark")}</p>`;
    })
    .catch(() => (body.innerHTML = `<div class="bw-alert bw-alert--error">${t("credits.error")}</div>`));
};
